import React from "react";

const HelloReact = ({ message }) => (
  <div>
    <h1>{message}</h1>
    <p>React is working!</p>
  </div>
);

export default HelloReact;
